// src/components/CatalogoBelleza.jsx
import React from 'react';

function CatalogoBelleza() {
  return (
    <div
      style={{
        width: "100%",
        minHeight: "100vh",
        background: "linear-gradient(180deg, #FFFFFF 0%, #BFBFBF 100%)",
        fontFamily: "'Playfair Display', serif",
        padding: "20px",
        boxSizing: "border-box",
      }}
    >
      {/* Banner superior */}
      <div style={{ width: "100%", marginBottom: "30px" }}>
        <img
          src="/imagenes/LogoEvolushion.jpg"
          alt="Banner Institucional"
          style={{
            width: "100%",
            height: "auto",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          }}
        />
      </div>

      {/* Encabezado principal */}
      <header
        style={{
          textAlign: "center",
          padding: "20px 0",
          marginBottom: "40px",
        }}
      >
        <h1
          style={{
            fontSize: "3em",
            color: "#5C1F3E",
            fontWeight: "bold",
          }}
        >
          Instituto Profesional de Belleza Evolushion
        </h1>
        <p
          style={{
            fontSize: "1.2em",
            color: "#D9A8C4",
            marginTop: "10px",
          }}
        >
          Estilos que inspiran, belleza que transforma
        </p>
      </header>

      {/* Secciones alternadas */}
      {[
        {
          titulo: "ETAPA 1: DISEÑO CAPILAR",
          imagen: "/imagenes/Etapa1.jpg",
          contenidos: [
            "Corte de Cabello",
            "Peinado Casual",
            "Extensiones de Cabello",
            "Peinado Ceremonial",
            "Colorimetría",
            "Permacología y Alaciado Permanente",
          ],
        },
        {
          titulo: "ETAPA 2: MAQUILLAJE PROFESIONAL",
          imagen: "/imagenes/Etapa2.png",
          contenidos: [
            "Limpieza Facial",
            "Depilación",
            "Maquillaje Casual",
            "Rizado, Planchado, Pigmento de Ceja y Pestaña",
            "Extensión de Pestañas",
            "Maquillaje Ceremonial",
            "Maquillaje de Pasarela",
            "Maquillaje de Fantasía y Body Paint",
          ],
        },
        {
          titulo: "ETAPA 3: SPA EN PIES Y MANOS",
          imagen: "/imagenes/Etapa3.png",
          contenidos: [
            "Manicura, Pedicura y Reflexología",
            "Decoración y Aplicación de Uñas",
          ],
        },
      ].map((etapa, index) => (
        <section
          key={index}
          style={{
            display: "flex",
            flexDirection: index % 2 === 0 ? "row" : "row-reverse",
            alignItems: "center",
            marginBottom: "60px",
            gap: "40px",
            flexWrap: "wrap",
          }}
        >
          <img
            src={etapa.imagen}
            alt={etapa.titulo}
            style={{
              width: "35%",
              borderRadius: "20px",
              boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
            }}
          />
          <div
            style={{
              flex: "1",
              background: "#FFFFFF",
              borderRadius: "12px",
              padding: "30px",
              boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
              border: "1px solid #D9A8C4",
            }}
          >
            <h2
              style={{
                color: "#5C1F3E",
                fontSize: "1.6em",
                borderBottom: "2px solid #D9A8C4",
                paddingBottom: "10px",
                marginBottom: "20px",
              }}
            >
              {etapa.titulo}
            </h2>
            <ul
              style={{
                listStyleType: "disc",
                paddingLeft: "20px",
                color: "#3E3E3E",
                fontSize: "1em",
                lineHeight: "1.8",
              }}
            >
              {etapa.contenidos.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          </div>
        </section>
      ))}

      {/* Footer */}
      <footer
        style={{
          textAlign: "center",
          marginTop: "60px",
          color: "#3E3E3E",
          fontSize: "0.9em",
        }}
      >
        <section
          style={{
            background: "linear-gradient(to right, #ffe5ec, #fddde6)",
            padding: "80px 20px",
            fontFamily: "'Playfair Display', serif",
            position: "relative",
            overflow: "hidden",
            color: "#3a2c2c",
          }}
        >
          <div style={{
            position: "absolute",
            top: "-60px",
            left: "-60px",
            width: "300px",
            height: "300px",
            background: "radial-gradient(circle, #ffb6c1 0%, transparent 70%)",
            zIndex: 1,
            filter: "blur(60px)"
          }} />
          <div style={{
            position: "absolute",
            bottom: "-60px",
            right: "-60px",
            width: "300px",
            height: "300px",
            background: "radial-gradient(circle, #ffc0cb 0%, transparent 70%)",
            zIndex: 1,
            filter: "blur(60px)"
          }} />

          <div style={{
            zIndex: 2,
            position: "relative",
            maxWidth: "900px",
            margin: "0 auto",
            textAlign: "center",
            marginBottom: "60px"
          }}>
            <img
              src="/imagenes/ModMaq.jpg"
              alt="Modelo maquillándose"
              style={{
                width: "250px",
                borderRadius: "50%",
                boxShadow: "0 6px 20px rgba(0,0,0,0.2)",
                marginBottom: "20px"
              }}
            />
            <h2 style={{
              fontSize: "3rem",
              color: "#8b1e47",
              marginBottom: "10px"
            }}>
              Maquillaje Profesional
            </h2>
            <p style={{
              fontSize: "1.2rem",
              color: "#5f2d3a",
              fontStyle: "italic"
            }}>
              "Detalles que realzan tu arte"
            </p>
          </div>

          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "30px",
            maxWidth: "1200px",
            margin: "0 auto",
            zIndex: 2,
            position: "relative"
          }}>
            {/* Tarjetas */}
            {[ /* ... array con objetos de tarjetas ... */ 
              {
                title: "Fundamentos del Maquillaje",
                items: ["Teoría del color", "Visagismo", "Efectos de las Texturas", "Teorias del Claro Oscuro", "Tipos de Osamenta", "Tipos de Rostro", "Correcciones"],
              },
              {
                title: "Propósito del Maquillaje",
                items: ["Imagen del maquillador", "Útiles de Trabajo", "Estación de Trabajo", "Higiene Cosmética", "Caducidad Cosmética"],
              },
              {
                title: "Depilación",
                items: ["Zonas de vello", "Materiales", "Higiene y Saneamiento", "Métodos de depilación y epilación"],
              },
              {
                title: "Sombreados",
                items: ["Smokey Eyes", "Cut Cruise", "Anatómico Abierto", "Anatómico Cerrado", "Delineados"],
              },
              {
                title: "Limpieza Facial - Hidratación - Humectación",
                items: ["La Piel", "Tipos de Piel", "Tipos de Humectantes e Hidratantes"],
              },
              {
                title: "Imagen del Rostro",
                items: ["Equilibrios de Maquillaje", "Cejas", "Aplicación de bases", "Tipos de Ojos", "Aplicación de Pestañas"],
              },
              {
                title: "Resolución en Casos de Ojos",
                items: ["Ojos Encapotados", "Parpados Pequeños", "Parpados Prominentes", "Ojos Hundidos"],
              },
              {
                title: "Tipos de Maquillaje",
                items: ["Maquillaje Social", "Novia", "XV", "Graduación", "Pasarela", "Red Carpet", "Beauty", "Drag Make Up", "Época", "Pop Art"],
              },
              {
                title: "Resolución de Casos en Piel",
                items: ["Productos", "Densidad e Intensidad", "Piel Madura", "Lunares", "Piel Olivácea", "Paño", "Cubrimiento de Tatuaje"],
              },
              {
                title: "Body Paint y Fantasía",
                items: ["Productos Cosméticos", "Herramientas", "Seguridad e Higiene", "Face Chart", "Uso del Glitter y la Purpurina"],
              }
            ].map((section, index) => (
              <div
                key={index}
                style={{
                  background: "#ffffffee",
                  padding: "20px",
                  borderRadius: "20px",
                  boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                  backdropFilter: "blur(5px)",
                  transition: "transform 0.3s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                <h3 style={{ fontSize: "1.2rem", color: "#af2d61", marginBottom: "10px" }}>{section.title}</h3>
                <ul style={{ paddingLeft: "20px", color: "#4b2d2d", fontSize: "0.95rem" }}>
                  {section.items.map((item, i) => (
                    <li key={i} style={{ marginBottom: "5px" }}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>

        {/* Segunda sección */}
        <section
          style={{
            background: "linear-gradient(180deg,rgb(253, 242, 255) 0%,rgb(241, 224, 246) 100%)",
            padding: "100px 5%",
            fontFamily: "'Lora', serif",
            color: "#3E3E3E",
          }}
        >
          <div
            style={{
              textAlign: "center",
              marginBottom: "80px",
              maxWidth: "800px",
              marginInline: "auto",
            }}
          >
            <h1
              style={{
                fontFamily: "'Playfair Display', serif",
                fontSize: "3.5rem",
                color: "#AF446B",
                marginBottom: "20px",
              }}
            >
              Lashista Profesional
            </h1>
            <p
              style={{
                fontSize: "1.25rem",
                lineHeight: "1.8",
                color: "#7D4E57",
              }}
            >
              Eleva tu talento, domina las técnicas de extensiones de pestañas y crea
              miradas impactantes con precisión.
            </p>
            <div
              style={{
                margin: "30px auto 0",
                width: "100px",
                height: "4px",
                backgroundColor: "#AF446B",
                borderRadius: "2px",
              }}
            />
          </div>
          {/* SECCIÓN PRINCIPAL */}
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "50px",
      alignItems: "start",
      marginBottom: "100px",
    }}
  >
    {/* IMÁGENES */}
    <div style={{ display: "flex", flexDirection: "column", gap: "30px" }}>
      <img
        src="/imagenes/lashista.jpg"
        alt="Curso Cejas"
        style={{
          width: "70%",
          borderRadius: "20px",
          boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
          objectFit: "cover",
        }}
      />
      <img
        src="/imagenes/Diseñodecejas.jpg"
        alt="Curso Pestañas"
        style={{
          width: "70%",
          borderRadius: "20px",
          boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
          objectFit: "cover",
        }}
      />
      <img
        src="/imagenes/RizadoPermanenteDePestañas.jpg"
        alt="Curso Pestañas"
        style={{
          width: "75%",
          borderRadius: "20px",
          boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
          objectFit: "cover",
        }}
      />
    </div>

    {/* MÓDULOS */}
    <div style={{ display: "flex", flexDirection: "column", gap: "30px" }}>
      {/* Tarjeta Conocimientos Previos */}
      <div
        style={{
          background: "rgba(239, 220, 245, 0.85)",
          padding: "32px",
          borderRadius: "16px",
          borderLeft: "6px solid #AF446B",
          boxShadow: "0 8px 20px rgba(0,0,0,0.05)",
        }}
      >
        <h2
          style={{
            fontSize: "1.5rem",
            color: "#AF446B",
            marginBottom: "16px",
          }}
        >
          Conocimientos Previos
        </h2>
        <ul
          style={{
            listStyle: "disc",
            paddingLeft: "20px",
            color: "#7D4E57",
            fontSize: "1rem",
            lineHeight: "1.75",
          }}
        >
          <li>Conceptos básicos</li>
          <li>Tipos de rostro</li>
          <li>Tipos de ojos</li>
        </ul>
      </div>

      {/* Tarjeta Pestañas */}
      <div
        style={{
          background: "rgba(239, 220, 245, 0.85)",
          padding: "32px",
          borderRadius: "16px",
          borderLeft: "6px solid #AF446B",
          boxShadow: "0 8px 20px rgba(0,0,0,0.05)",
        }}
      >
        <h2
          style={{
            fontSize: "1.5rem",
            color: "#AF446B",
            marginBottom: "16px",
          }}
        >
          Pestañas
        </h2>
        <ul
          style={{
            listStyle: "disc",
            paddingLeft: "20px",
            color: "#7D4E57",
            fontSize: "1rem",
            lineHeight: "1.75",
          }}
        >
          <li>Rizado permanente de pestañas</li>
          <li>Pigmento de pestañas</li>
          <li>Tipos de pestañas</li>
          <li>Técnicas de fijación</li>
          <li>Tipos de adhesivo</li>
          <li>Extensiones de pestañas</li>
          <li>Ciclo de vida de las pestañas</li>
          <li>Retoques</li>
          <li>Retiros</li>
          <li>Cuidados posteriores</li>
          <li>Aplicación clásica</li>
          <li>Técnica Ojo de Gato</li>
          <li>Técnica Ojo de Muñeca</li>
          <li>Técnica Ojo de Ardilla</li>
          <li>Técnica Ojo Abierto</li>
          <li>Técnica Wispy</li>
          <li>Técnica Fibras Tecnológicas</li>
          <li>Técnica Híbrida</li>
          <li>Técnica Volumen c/Fibra Tec.</li>
          <li>Técnica Hawaiana</li>
        </ul>
      </div>

      {/* Tarjeta Cejas */}
      <div
        style={{
          background: "rgba(239, 220, 245, 0.85)",
          padding: "32px",
          borderRadius: "16px",
          borderLeft: "6px solid #AF446B",
          boxShadow: "0 8px 20px rgba(0,0,0,0.05)",
        }}
      >
        <h2
          style={{
            fontSize: "1.5rem",
            color: "#AF446B",
            marginBottom: "16px",
          }}
        >
          Cejas
        </h2>
        <ul
          style={{
            listStyle: "disc",
            paddingLeft: "20px",
            color: "#7D4E57",
            fontSize: "1rem",
            lineHeight: "1.75",
          }}
        >
          <li>Tipos de cejas</li>
          <li>Diseño de cejas</li>
          <li>Técnica</li>
          <li>Planchado de ceja</li>
          <li>Pigmento de ceja</li>
          <li>Técnica Cejas 4K</li>
        </ul>
      </div>
    </div>
  </div>

  <div
    style={{
      width: "100%",
      display: "flex",
      justifyContent: "center",
      padding: "60px 20px",
    }}
  >
    <div>
      <h2
        style={{
          fontSize: "2rem",
          color: "#AA446B",
          fontWeight: "700",
          marginBottom: "16px",
          textAlign: "center",
        }}
      >
        Especialidad Avanzada
      </h2>

      <p>
        Disponible solo para quienes hayan finalizado el curso completo de Lashista Profesional.
        Perfecciona tus técnicas con estilos de alto nivel:
      </p>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: "20px",
          fontSize: "1rem",
          fontWeight: "600",
          color: "#333",
        }}
      >
        <span>Estilo Rímel</span>
        <span>Estilo Mojado</span>
        <span>Estilo Fox Eye</span>
        <span>Estilo Anime</span>
        <span>Estilo Kim K</span>
      </div>
    </div>
  </div>
        </section>
<section
  style={{
    backgroundColor: "#fff2f9",
    color: "#1a1a1a",
    fontFamily: "'Poppins', 'Inter', sans-serif",
    padding: "0",
  }}
>
  <div style={{ padding: "60px 5%", maxWidth: "1200px", margin: "0 auto" }}>
    <div style={{ textAlign: "center", marginBottom: "60px" }}>
      <h1
        style={{
          fontSize: "3.2rem",
          color: "#e60073",
          fontWeight: "900",
          letterSpacing: "-0.5px",
        }}
      >
        Curso Profesional de Uñas
      </h1>
      <p
        style={{
          fontSize: "1.3rem",
          color: "#333",
          marginTop: "16px",
          fontWeight: "500",
        }}
      >
        Aprende estructuras, técnicas y decoraciones en tendencia con un enfoque artístico y profesional.
      </p>
    </div>

    {/* BLOQUE 1 */}
    <div
      style={{
        display: "flex",
        gap: "40px",
        alignItems: "center",
        marginBottom: "60px",
        flexWrap: "wrap",
      }}
    >
      <div style={{ flex: 1, textAlign: "center" }}>
        <img
          src="/imagenes/EstructurasUñas.jpg"
          alt="Conocimientos Básicos"
          style={{
            maxWidth: "480px",
            height: "auto",
            borderRadius: "16px",
            boxShadow: "0 6px 14px rgba(0,0,0,0.12)",
            margin: "0 auto",
            display: "block",
          }}
        />
      </div>
      <div
        style={{
          flex: 1,
          background: "#ffffff",
          padding: "30px",
          borderRadius: "16px",
          boxShadow: "0 6px 16px rgba(255, 182, 193, 0.25)",
          borderLeft: "6px solid #e60073",
        }}
      >
        <h2 style={{ color: "#e60073", fontSize: "1.5rem", fontWeight: "700" }}>
          *Conocimientos Básicos
        </h2>
        <h2 style={{ color: "#e60073", fontSize: "1.5rem", fontWeight: "700" }}>
          *Técnicas Básicas
        </h2>
        <ul style={{ paddingLeft: "20px", lineHeight: "1.8" }}>
          {["Baby Boomer", "Reversa o alargamiento de almendra", "Encapsulado"].map(
            (item, i) => (
              <li key={`estruct1-${i}`}>{item}</li>
            )
          )}
        </ul>
        <h2 style={{ color: "#e60073", fontSize: "1.5rem", fontWeight: "700" }}>
          *Estructuras
        </h2>
        <ul style={{ paddingLeft: "20px", lineHeight: "1.8" }}>
          {[
            "Punta curva C", "Punta redonda", "Punta ovalada", "Punta cuadrada", "Punta diagonal",
            "Punta lanza", "Punta campana", "Punta pirámide", "Punta espiral", "Punta stiletto",
            "Punta pipe", "Punta baleriana",
          ].map((item, i) => (
            <li key={`estruct2-${i}`}>{item}</li>
          ))}
        </ul>
      </div>
    </div>

    {/* BLOQUE 2 */}
    <div
      style={{
        display: "flex",
        flexDirection: "row-reverse",
        gap: "40px",
        alignItems: "center",
        marginBottom: "60px",
        flexWrap: "wrap",
      }}
    >
      <div style={{ flex: 1, textAlign: "center" }}>
        <img
          src="/imagenes/DecoracionUñas.jpg"
          alt="Decoraciones"
          style={{
            maxWidth: "480px",
            height: "auto",
            borderRadius: "16px",
            boxShadow: "0 6px 14px rgba(0,0,0,0.12)",
            margin: "0 auto",
            display: "block",
          }}
        />
      </div>
      <div
        style={{
          flex: 1,
          background: "#ffffff",
          padding: "30px",
          borderRadius: "16px",
          boxShadow: "0 6px 16px rgba(255, 182, 193, 0.25)",
          borderLeft: "6px solid #e60073",
        }}
      >
        <h2 style={{ color: "#e60073", fontSize: "1.5rem", fontWeight: "700" }}>
          *Decoraciones Básicas
        </h2>
        <ul style={{ paddingLeft: "20px", lineHeight: "1.8" }}>
          {[
            "Periódico", "Tabaco", "Neo", "Cintilla", "Encaje", "Logos", "Francés", "Balines",
            "Bajo agua", "Red", "Hilo hindú", "Plumas", "Tierra", "Cadena", "Gelish",
            "Naturaleza muerta", "Ala de ángel", "Confeti", "Foil", "Tela", "Estoperoles",
          ].map((item, i) => (
            <li key={`decoracion-${i}`}>{item}</li>
          ))}
        </ul>

        <h2 style={{ color: "#e60073", fontSize: "1.5rem", fontWeight: "700", marginTop: "20px" }}>
          *Decoración Mano Alzada
        </h2>
        <ul style={{ paddingLeft: "20px", lineHeight: "1.8" }}>
          {[
            "Puntos", "Líneas", "Flores", "Animal print", "Diseños de temporada", "Degradé", "Bajo agua",
          ].map((item, i) => (
            <li key={`manoalzada-${i}`}>{item}</li>
          ))}
        </ul>

        <h2 style={{ color: "#e60073", fontSize: "1.5rem", fontWeight: "700", marginTop: "20px" }}>
          *Efectos
        </h2>
        <ul style={{ paddingLeft: "20px", lineHeight: "1.8" }}>
          {[
            "Hielo", "Espejo", "Terciopelo", "Ventana", "Gelatina", "Fileteado",
            "Cola de sirena", "Sinaloense", "Tejido", "Hueca", "Marmoleado",
            "Bajo relieve", "3D",
          ].map((item, i) => (
            <li key={`efectos-${i}`}>{item}</li>
          ))}
        </ul>
      </div>
    </div>

    {/* BLOQUE 3 */}
    <div
      style={{
        display: "flex",
        gap: "40px",
        alignItems: "center",
        marginBottom: "60px",
        flexWrap: "wrap",
      }}
    >
      <div style={{ flex: 1, textAlign: "center" }}>
        <img
          src="/imagenes/EfectosUñas.jpg"
          alt="Efectos y Tendencias"
          style={{
            maxWidth: "480px",
            height: "auto",
            borderRadius: "16px",
            boxShadow: "0 6px 14px rgba(0,0,0,0.12)",
            margin: "0 auto",
            display: "block",
          }}
        />
      </div>
      <div
        style={{
          flex: 1,
          background: "#ffffff",
          padding: "30px",
          borderRadius: "16px",
          boxShadow: "0 6px 16px rgba(255, 182, 193, 0.25)",
          borderLeft: "6px solid #e60073",
        }}
      >
        <h2
          style={{
            color: "#e60073",
            fontSize: "1.5rem",
            fontWeight: "700",
            marginBottom: "20px",
          }}
        >
          *Efectos y Tendencias
        </h2>
        <ul style={{ paddingLeft: "20px", lineHeight: "1.8" }}>
          {[
            "Dragón o Espuma", "Gotas de lluvia", "Baño de leche", "Baby boomer", "Acolchado",
            "Unicornio", "Acuarium", "Rainbow", "Lumina", "Azúcar", "Víboras", "Sirena", "Araña", "4D",
          ].map((item, i) => (
            <li key={`tendencia-${i}`}>{item}</li>
          ))}
        </ul>
      </div>
    </div>

    {/* BLOQUE FINAL */}
    <div
      style={{
        background: "#ffffff",
        padding: "30px",
        borderRadius: "16px",
        boxShadow: "0 6px 16px rgba(255, 182, 193, 0.25)",
        marginBottom: "60px",
        borderLeft: "6px solid #e60073",
        textAlign: "center",
      }}
    >
      {["*Manicura", "*Pedicura", "*Reflexología"].map((item, i) => (
        <h2
          key={`final-${i}`}
          style={{
            color: "#e60073",
            fontSize: "1.5rem",
            fontWeight: "700",
            margin: "10px 0",
          }}
        >
          {item}
        </h2>
      ))}
    </div>
  </div>
</section>
<section 
  style={{
    backgroundColor: "#A1866F",
    backgroundImage: "url('/imagenes/papelviejo.png')", // Asegúrate de tener esta imagen en tu proyecto
    backgroundRepeat: "repeat",
    backgroundSize: "cover",
    backgroundBlendMode: "multiply",
    color: "#1a1a1a",
    fontFamily: "'Inter', 'Montserrat', sans-serif",
    padding: "0",
  }}
>
  {/* Banner del logo */}
  <div style={{ width: "100%", overflow: "hidden", backgroundColor: "#A1866F" }}>
    <img
      src="/imagenes/LogoBarber2.jpg"
      alt="Logo Curso de Barbería"
      style={{
        width: "100%",
        height: "auto",
        display: "block",
        marginTop: "30px",
      }}
    />
  </div>

  {/* Contenido del catálogo */}
  <div style={{ padding: "60px 5%", maxWidth: "1200px", margin: "0 auto" }}>
    <div style={{ textAlign: "center", marginBottom: "60px" }}>
      <h1 style={{ fontSize: "3.2rem", color: "#B11226", fontWeight: "900", letterSpacing: "-1px" }}>
        Curso de Barbería Profesional
      </h1>
      <p style={{ fontSize: "1.3rem", color: "#333", marginTop: "16px", fontWeight: "500" }}>
        Aprende el arte del barbero clásico y moderno con enfoque profesional.
      </p>
    </div>

    {[
      {
        titulo: "Corte de Cabello",
        imagen: "/imagenes/CorteDeCabelloH.jpg",
        contenido: [
          "Introducción a la peluquería",
          "El puesto de trabajo en la peluquería masculina y barbería",
          "Conocimientos básicos",
          "Herramientas y útiles para el trabajo",
          "Higiene y seguridad",
          "El corte masculino",
          "Técnicas básicas de corte de cabello",
          "Cortes de pelo: fade estilos y/o variantes",
          "Configuración de patillas",
          "Acabado de cabello y nuca",
          "Estilos de peinados masculinos",
        ],
      },
      {
        titulo: "Barbería",
        imagen: "/imagenes/Barba.jpg",
        contenido: [
          "Estudio del rostro",
          "Técnicas de afeitado",
          "Cosméticos utilizados en el afeitado",
          "Análisis de la piel",
          "Diseño y estilo de barba y bigote",
          "Preparación del rostro",
          "Procedimiento de afeitado",
          "Ritual del afeitado",
        ],
      },
      {
        titulo: "Color",
        imagen: "/imagenes/pigBarba.jpeg",
        contenido: [
          "Aplicación de tinte homogénea",
          "Suavización de canas",
          "Técnicas de cambios de color en barba y bigote",
          "Acabados de fantasía y creaciones innovadoras",
        ],
      },
    ].map((bloque, idx) => (
      <div
        key={idx}
        style={{
          display: "flex",
          flexDirection: idx % 2 === 0 ? "row" : "row-reverse",
          gap: "40px",
          alignItems: "flex-start",
          marginBottom: "60px",
          flexWrap: "wrap",
        }}
      >
        <img
          src={bloque.imagen}
          alt={bloque.titulo}
          style={{
            width: "320px",
            height: "auto",
            borderRadius: "16px",
            boxShadow: "0 6px 14px rgba(0,0,0,0.15)",
            flexShrink: 0,
          }}
        />
        <div
          style={{
            flex: 1,
            background: "#fff",
            padding: "30px",
            borderRadius: "16px",
            boxShadow: "0 6px 16px rgba(0,0,0,0.08)",
            borderLeft: "6px solid #B11226",
          }}
        >
          <h2 style={{ color: "#B11226", fontSize: "1.5rem", marginBottom: "20px", fontWeight: "700" }}>
            {bloque.titulo}
          </h2>
          <ul style={{ paddingLeft: "20px", lineHeight: "1.8", fontWeight: "400" }}>
            {bloque.contenido.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    ))}

    {/* Formación Laboral */}
    <div
      style={{
        background: "#fff",
        padding: "30px",
        borderRadius: "16px",
        boxShadow: "0 6px 16px rgba(0,0,0,0.08)",
        marginBottom: "60px",
        borderLeft: "6px solid #B11226",
      }}
    >
      <h2 style={{ color: "#B11226", fontSize: "1.5rem", marginBottom: "20px", fontWeight: "700" }}>
        Formación Laboral
      </h2>
      <ul style={{ paddingLeft: "20px", lineHeight: "1.8", fontWeight: "400" }}>
        <li>Atención al cliente</li>
        <li>Marketing</li>
        <li>Constitución y apertura de un negocio</li>
      </ul>
    </div>

    {/* Tratamientos y Depilación */}
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "40px",
        marginBottom: "60px",
      }}
    >
      <div
        style={{
          flex: 1,
          background: "#fff",
          padding: "30px",
          borderRadius: "16px",
          boxShadow: "0 6px 16px rgba(0,0,0,0.08)",
          borderLeft: "6px solid #B11226",
        }}
      >
        <h2 style={{ color: "#B11226", fontSize: "1.5rem", marginBottom: "20px", fontWeight: "700" }}>
          Tratamientos Capilares
        </h2>
        <ul style={{ paddingLeft: "20px", lineHeight: "1.8", fontWeight: "400" }}>
          <li>Sequedad excesiva</li>
          <li>Dermatitis seborrea</li>
          <li>Caspa</li>
          <li>Tratamientos para la calvicie</li>
        </ul>
      </div>
      <div
        style={{
          flex: 1,
          background: "#fff",
          padding: "30px",
          borderRadius: "16px",
          boxShadow: "0 6px 16px rgba(0,0,0,0.08)",
          borderLeft: "6px solid #B11226",
        }}
      >
        <h2 style={{ color: "#B11226", fontSize: "1.5rem", marginBottom: "20px", fontWeight: "700" }}>
          Depilación
        </h2>
        <ul style={{ paddingLeft: "20px", lineHeight: "1.8", fontWeight: "400" }}>
          <li>Depilación facial masculina</li>
          <li>Zonas de depilación masculina</li>
          <li>Técnicas y procedimientos</li>
        </ul>
      </div>
    </div>
  </div>
</section>
<section
  style={{
    backgroundColor: "#f5f0e6",
    color: "#1a1a1a",
    fontFamily: "'Inter', sans-serif",
    padding: "0",
  }}
>
  {/* Contenido del curso unificado */}
  <div style={{ padding: "80px 5%", maxWidth: "1200px", margin: "0 auto" }}>
    <div style={{ textAlign: "center", marginBottom: "60px" }}>
      <h1
        style={{
          fontSize: "3rem",
          color: "#7a1e2c",
          fontFamily: "'Playfair Display', serif",
          fontWeight: "bold",
        }}
      >
        Alta Peluquería
      </h1>
      <p style={{ fontSize: "1.2rem", color: "#333", marginTop: "16px" }}>
        Formación integral en técnicas de corte, color, tratamientos y más.
      </p>
    </div>

    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1.2fr",
        gap: "40px",
        alignItems: "center",
        backgroundColor: "#fff",
        borderRadius: "20px",
        padding: "50px",
        border: "2px solid #7a1e2c",
        boxShadow: "0 12px 24px rgba(0,0,0,0.05)",
      }}
    >
      <div>
        <img
          src="/imagenes/CursoAltaPeluqueria.png"
          alt="Contenido del curso"
          style={{
            width: "100%",
            borderRadius: "16px",
            boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
          }}
        />
      </div>

      <div>
        <h2
          style={{
            fontSize: "1.8rem",
            color: "#7a1e2c",
            fontFamily: "'Playfair Display', serif",
            marginBottom: "24px",
            borderBottom: "2px solid #7a1e2c",
            paddingBottom: "12px",
          }}
        >
          Contenido del Curso
        </h2>
        <div
          style={{
            columnCount: 2,
            columnGap: "40px",
            fontSize: "1rem",
            lineHeight: "1.8",
            color: "#333",
          }}
        >
          {[
            "El cabello y las estructuras faciales",
            "Conocimientos previos",
            "Herramientas y accesorios de trabajo",
            "Seguridad e higiene",
            "Factores de éxito para un corte de cabello",
            "Técnicas de grados de elevación",
            "Preparación del cliente para el servicio",
            "Técnicas de corte",
            "Técnicas de texturizado",
            "Cortes de cabello para dama",
            "Cortes de cabello para caballero",
            "Barbería",
            "Combinaciones de formas",
            "Tendencias en el corte de cabello",
            "Color",
            "Depilación facial masculina",
            "Tratamientos capilares",
            "Formación laboral y empresarial",
          ].map((item, idx) => (
            <p key={idx} style={{ breakInside: "avoid", marginBottom: "10px" }}>
              • {item}
            </p>
          ))}
        </div>
      </div>
    </div>
  </div>
</section>
<section
  style={{
    backgroundColor: "#f0fdf4",
    color: "#1a1a1a",
    fontFamily: "'Poppins', sans-serif",
    padding: "0",
  }}
>
  {/* Contenido */}
  <div style={{ padding: "60px 5%", maxWidth: "1200px", margin: "0 auto" }}>
    <div style={{ textAlign: "center", marginBottom: "50px" }}>
      <h1
        style={{
          fontSize: "3rem",
          color: "#007a33",
          fontWeight: "900",
          letterSpacing: "-0.5px",
        }}
      >
        Computación Básica
      </h1>
      <p style={{ fontSize: "1.2rem", color: "#444", marginTop: "16px" }}>
        Curso práctico para aprender el uso esencial de herramientas digitales modernas.
      </p>
    </div>

    {/* Lista de módulos con imágenes */}
    {[
      {
        titulo: "Entorno al sistema",
        descripcion: "Uso básico del sistema operativo, manejo de carpetas, archivos y configuración general.",
        imagen: "/imagenes/EntornoAlSistema.png",
        reverso: false,
      },
      {
        titulo: "Word - Docs Google",
        descripcion: "Procesadores de texto para redactar, dar formato y compartir documentos.",
        imagen: "/imagenes/Word.jpg",
        reverso: true,
      },
      {
        titulo: "Internet - Redes sociales - Apps Google",
        descripcion: "Navegación segura en internet, uso de redes sociales y herramientas como Gmail, Drive y Calendar.",
        imagen: "/imagenes/Internet.jpg",
        reverso: false,
      },
      {
        titulo: "Power Point - Presentaciones Google - Prezi",
        descripcion: "Creación de presentaciones dinámicas con animaciones, texto e imágenes.",
        imagen: "/imagenes/PowerPoint.jpg",
        reverso: true,
      },
      {
        titulo: "Excel - Hojas de cálculo Google",
        descripcion: "Uso de hojas de cálculo para crear tablas, fórmulas y análisis de datos básicos.",
        imagen: "/imagenes/Excel.jpg",
        reverso: false,
      },
      {
        titulo: "Publisher",
        descripcion: "Diseño de folletos, trípticos y documentos gráficos listos para impresión.",
        imagen: "/imagenes/Publi.jpg",
        reverso: true,
      },
    ].map((modulo, index) => (
      <div
        key={index}
        style={{
          display: "flex",
          flexDirection: modulo.reverso ? "row-reverse" : "row",
          gap: "40px",
          alignItems: "center",
          marginBottom: "60px",
          flexWrap: "wrap",
        }}
      >
        <div style={{ flex: 1 }}>
          <h2 style={{ color: "#007a33", fontSize: "1.6rem", fontWeight: "700" }}>
            {modulo.titulo}
          </h2>
          <p style={{ lineHeight: "1.8", fontSize: "1.1rem" }}>{modulo.descripcion}</p>
        </div>
        <div style={{ flex: 1, textAlign: "center" }}>
          <img
            src={modulo.imagen}
            alt={modulo.titulo}
            style={{
              maxWidth: "450px",
              borderRadius: "12px",
              boxShadow: "0 6px 14px rgba(0,0,0,0.1)",
              display: "block",
              margin: "0 auto",
            }}
          />
        </div>
      </div>
    ))}
  </div>
</section>
<section
  style={{
    backgroundColor: "#fff9f5",
    fontFamily: "'Poppins', sans-serif",
    color: "#1f1f1f",
    padding: "60px 5%",
  }}
>
  {/* Encabezado */}
  <div style={{ textAlign: "center", marginBottom: "40px" }}>
    <h1 style={{ fontSize: "3rem", fontWeight: "800", color: "#e4572e" }}>
      Administración y Control de Negocios
    </h1>
    <p style={{ fontSize: "1.2rem", maxWidth: "700px", margin: "20px auto", color: "#444" }}>
      Domina las herramientas clave para emprender, organizar, administrar y hacer crecer tu negocio con enfoque profesional.
    </p>
  </div>

  {/* Primera sección con imagen al lado */}
  <div style={{ display: "flex", gap: "40px", alignItems: "flex-start", flexWrap: "wrap", marginBottom: "60px" }}>
    <div style={{ flex: "1 1 500px" }}>
      {[
        {
          titulo: "Desarrollo e innovación empresarial",
          descripcion: "Crea nuevas propuestas y mejora continua en productos o servicios.",
        },
        {
          titulo: "Administración",
          descripcion: "Gestiona los recursos y procesos para maximizar la eficiencia empresarial.",
        },
        {
          titulo: "Planeación estratégica",
          descripcion: "Define la ruta del negocio con visión a largo plazo y decisiones acertadas.",
        },
      ].map((item, idx) => (
        <div
          key={idx}
          style={{
            marginBottom: "25px",
            backgroundColor: "#ffffff",
            borderLeft: "6px solid #e4572e",
            padding: "20px",
            borderRadius: "10px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.06)",
          }}
        >
          <h2 style={{ fontSize: "1.2rem", fontWeight: "700" }}>{item.titulo}</h2>
          <p style={{ fontSize: "1rem", color: "#555" }}>{item.descripcion}</p>
        </div>
      ))}
    </div>

    {/* Imagen lateral */}
    <div style={{ flex: "1 1 350px", textAlign: "center" }}>
      <img
        src="/imagenes/ControlDeNeg.jpg"
        alt="Liderazgo empresarial"
        style={{
          width: "350px",
          height: "auto",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        }}
      />
    </div>
  </div>

  {/* Imagen separadora */}
  <div style={{ textAlign: "center", margin: "40px 0" }}>
    <img
      src="/imagenes/Administracion.jpg"
      alt="Equipo empresarial"
      style={{
        width: "350px",
        height: "auto",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
      }}
    />
  </div>

  {/* Segunda sección */}
  <div style={{ maxWidth: "1000px", margin: "0 auto", marginTop: "40px" }}>
    {[
      {
        titulo: "Desarrollo organizacional",
        descripcion: "Optimiza la estructura interna para un mejor desempeño del equipo.",
      },
      {
        titulo: "Integración de capital humano",
        descripcion: "Selecciona, organiza y lidera tu equipo humano con efectividad.",
      },
      {
        titulo: "Mercadotecnia",
        descripcion: "Aplica estrategias para llegar al mercado adecuado y aumentar ventas.",
      },
      {
        titulo: "Construcción y apertura de una empresa (Marco legal)",
        descripcion: "Cumple requisitos y formaliza tu empresa legalmente.",
      },
      {
        titulo: "Impuestos",
        descripcion: "Conoce tus obligaciones fiscales y mantén tu empresa en regla.",
      },
      {
        titulo: "Nóminas - SUA",
        descripcion: "Administra el pago de empleados y las obligaciones ante el IMSS.",
      },
      {
        titulo: "Contabilidad, inventarios y facturación electrónica",
        descripcion: "Controla tu flujo financiero con herramientas digitales prácticas.",
      },
      {
        titulo: "Análisis económico financiero",
        descripcion: "Toma decisiones con base en indicadores reales y financieros.",
      },
    ].map((item, idx) => (
      <div
        key={idx}
        style={{
          marginBottom: "25px",
          backgroundColor: "#ffffff",
          borderLeft: "6px solid #e4572e",
          padding: "20px",
          borderRadius: "10px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.06)",
        }}
      >
        <h2 style={{ fontSize: "1.2rem", fontWeight: "700" }}>{item.titulo}</h2>
        <p style={{ fontSize: "1rem", color: "#555" }}>{item.descripcion}</p>
      </div>
    ))}
  </div>

  {/* Imagen decorativa de cierre */}
  <div style={{ textAlign: "center", marginTop: "40px" }}>
    <img
      src="/imagenes/FinanzasYAnalisis.jpg"
      alt="Finanzas y análisis"
      style={{
        width: "350px",
        height: "auto",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
      }}
    />
  </div>
</section>
<section
  style={{
    fontFamily: "'Poppins', sans-serif",
    backgroundColor: "#FFFFFF",
    color: "#2C2C2C",
    padding: "60px 5%",
    maxWidth: "1200px",
    margin: "0 auto",
  }}
>
  {/* Encabezado principal */}
  <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      gap: "40px",
      justifyContent: "center",
      marginBottom: "80px",
      borderBottom: "3px solid #E8F1FA",
      paddingBottom: "40px",
    }}
  >
    <div style={{ flex: "1 1 400px", minWidth: "280px" }}>
      <h1
        style={{
          fontSize: "3.2rem",
          fontWeight: "700",
          marginBottom: "24px",
          color: "#005B96",
          letterSpacing: "1.2px",
          lineHeight: "1.1",
        }}
      >
        Computación Administrativa
      </h1>
      <p
        style={{
          fontSize: "1.15rem",
          lineHeight: "1.8",
          fontWeight: "300",
          maxWidth: "520px",
          color: "#444444",
        }}
      >
        Aprende a manejar herramientas tecnológicas clave para el entorno empresarial y administrativo moderno. Este curso te brinda habilidades prácticas y aplicables desde el primer día.
      </p>
    </div>
    <div style={{ flex: "1 1 400px", textAlign: "center" }}>
      <img
        src="/imagenes/computacionEmpresarial.png"
        alt="Computación Empresarial"
        style={{
          width: "100%",
          maxWidth: "420px",
          border: "6px solid white",
          borderRadius: "12px",
          boxShadow: "0 8px 15px rgba(0, 91, 150, 0.3)",
          transition: "transform 0.4s ease",
          cursor: "pointer",
        }}
        onMouseEnter={e => (e.currentTarget.style.transform = "scale(1.07)")}
        onMouseLeave={e => (e.currentTarget.style.transform = "scale(1)")}
      />
    </div>
  </div>

  {/* Temas y imagen sección con fondo alternado */}
  <div
    style={{
      backgroundColor: "#E8F1FA",
      padding: "60px 5%",
      borderRadius: "12px",
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
      gap: "48px",
      alignItems: "center",
      boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
    }}
  >
    <div>
      <h2
        style={{
          fontSize: "2rem",
          fontWeight: "700",
          color: "#005B96",
          marginBottom: "28px",
          letterSpacing: "0.8px",
        }}
      >
        Temas que dominarás
      </h2>
      <ul style={{ listStyle: "none", padding: 0, maxWidth: "480px" }}>
        {[
          "Word",
          "PowerPoint",
          "Excel",
          "Photoshop",
          "CorelDRAW",
          "Impuestos (SAT)",
          "Nómina y SUA",
          "Contabilidad",
          "Facturación electrónica",
        ].map((item, idx) => (
          <li
            key={idx}
            style={{
              backgroundColor: "#FFFFFF",
              padding: "18px 22px",
              borderRadius: "10px",
              marginBottom: "14px",
              fontWeight: "600",
              color: "#2C2C2C",
              border: "2px solid #005B96",
              boxShadow: "0 4px 10px rgba(0, 91, 150, 0.15)",
              cursor: "default",
              transition: "background-color 0.3s ease",
            }}
          >
            {item}
          </li>
        ))}
      </ul>
    </div>

    <div style={{ textAlign: "center" }}>
      <img
        src="/imagenes/Empresarial.jpg"
        alt="Presentación Digital"
        style={{
          width: "100%",
          maxWidth: "420px",
          border: "6px solid white",
          borderRadius: "14px",
          boxShadow: "0 8px 20px rgba(0, 91, 150, 0.3)",
          transition: "transform 0.4s ease",
          cursor: "pointer",
        }}
        onMouseEnter={e => (e.currentTarget.style.transform = "scale(1.07)")}
        onMouseLeave={e => (e.currentTarget.style.transform = "scale(1)")}
      />
    </div>
  </div>
</section>
<section
  style={{
    fontFamily: "'Poppins', sans-serif",
    backgroundColor: "#F4F9F9",
    color: "#2C3E50",
    lineHeight: 1.6,
  }}
>
  {/* Sección 1: Introducción con fondo dividido */}
  <div style={{ display: "flex", flexWrap: "wrap", minHeight: "400px" }}>
    <div
      style={{
        flex: "1 1 50%",
        background: "#FFFFFF",
        padding: "60px",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div>
        <h1 style={{ fontSize: "3rem", marginBottom: "20px", color: "#2C3E50" }}>
          Curso de Diseño Gráfico
        </h1>
        <p style={{ fontSize: "1.1rem", color: "#4A6FA5", maxWidth: "500px" }}>
          Aprende a crear, editar y comunicar visualmente con herramientas digitales y fundamentos de diseño.
        </p>
      </div>
    </div>
    <div
      style={{
        flex: "1 1 50%",
        backgroundImage: "url('/imagenes/digital.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    />
  </div>

  {/* Sección 2: Lista de herramientas con cards */}
  <div style={{ padding: "80px 5%", backgroundColor: "#F4F9F9" }}>
    <h2 style={{ fontSize: "2rem", textAlign: "center", marginBottom: "60px", color: "#2C3E50" }}>
      Domina las herramientas más usadas
    </h2>
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
        gap: "30px",
      }}
    >
      {[
        ["Digitalización y Tratamiento de Imágenes", "/imagenes/Tratamiento.jpg"],
        ["Fotografía Digital (Photoshop)", "/imagenes/Photo.jpg"],
        ["Diseño y Publicidad I (Corel Draw)", "/imagenes/corel.jpg"],
        ["Diseño y Publicidad II (Il lustrator)", "/imagenes/Ilus.png"],
        ["Efectos Digitales (Flash)", "/imagenes/Flash.png"],
        ["Diseño 3D (Sketshup)", "/imagenes/Sket.png"],
      ].map(([name, img], i) => (
        <div
          key={i}
          style={{
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 8px 24px rgba(0,0,0,0.07)",
            backgroundColor: "#FFFFFF",
            transition: "transform 0.3s, border 0.3s",
            border: "2px solid transparent",
            cursor: "pointer",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.border = "2px solid #FF6B6B")}
          onMouseLeave={(e) => (e.currentTarget.style.border = "2px solid transparent")}
        >
          <div style={{ width: "100%", height: "180px", backgroundColor: "#EAEAEA" }}>
            <img
              src={img}
              alt={name}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          </div>
          <div style={{ padding: "20px", textAlign: "center", fontWeight: 500, color: "#4A6FA5" }}>
            {name}
          </div>
        </div>
      ))}
    </div>
  </div>

  {/* Sección 3: Texto con fondo artístico elegante */}
  <div
    style={{
        backgroundImage: "linear-gradient(to right, #1786a0, #0f2d45)",
        color: "#F5F5F7",
        padding: "60px 5%", 
        textAlign: "center",
    }}
  >
    <h2 style={{ fontSize: "2.2rem", marginBottom: "20px", color: "#F4F9F9" }}>
      Aprende desde el primer día
    </h2>
    <p style={{ maxWidth: "700px", margin: "0 auto", fontSize: "1.1rem", color: "#F4F9F9" }}>
      Cada clase está diseñada para que pongas en práctica tus ideas y construyas proyectos visuales impactantes desde el inicio.
    </p>
  </div>
</section>
      </footer>
    </div>
  );
}

export default CatalogoBelleza;
